import './Speakers.css';
import SpeakerRow from './SpeakerRow';

export default function Speakers({ conference = {} } = {}) {
    const speakers = conference.speakers || [];

    return `
        <section id="speakers" class="speakers">
            <div class="speakers__container">
                <div class="speakers__header">
                    <span class="speakers__eyebrow"></span>
                    <h2 class="speakers__title">Invited Speakers</h2>
                </div>

               <div class="speakers__grid">
    ${
        speakers.length
            ? speakers.map(SpeakerRow).join('')
            : `
                <p class="speakers__empty">
                    Invited speakers will be announced later.
                </p>
            `
    }
</div>
            </div>
        </section>
    `;
}
